var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoldertree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.1046 12 14 11.1046 14 10V7C14 5.89543 13.1046 5 12 5H2C0.895431 5 0 5.89543 0 7L0 10C0 11.1046 0.895431 12 2 12H12Z",
    fill: "#FACC15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.76389L0 2C0 0.895431 0.895431 0 2 0L5.58579 0C5.98361 0 6.36514 0.158035 6.64645 0.43934L8.06066 1.85355C8.15443 1.94732 8.2816 2 8.41421 2H12C13.1046 2 14 2.89543 14 4V4.76389C13.4692 4.28885 12.7684 4 12 4H2C1.23165 4 0.530757 4.28885 0 4.76389Z",
    fill: "#FACC15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldertree);
export default __webpack_public_path__ + "static/media/foldertree.0e7bae2c82ba95e3d156204a2493382c.svg";
export { ForwardRef as ReactComponent };